import {
  SpotSanityDetail,
  SpotSanityListEvent
} from '@/ui/components/SpotSanity/SpotSanity'

import {
  toSectionCta,
  toSectionCtaSingle,
  toSectionFeature,
  toSectionSlider,
  toSectionUpcomingEvents
} from '@/lib/transformers'

import { Typo3SectionSpotSanityEventList } from '@/types/typo3'

import {
  SectionCta,
  SectionCtaSingle,
  SectionFeature,
  SectionSlider,
  SectionUpcomingEvents
} from '@/ui/Sections'

import { memo, Suspense } from 'react'
import { SectionCtaProps } from '../SectionCta/SectionCta'
import { SectionFeatureProps } from '../SectionFeature/type'

interface Props {
  data: Typo3SectionSpotSanityEventList
}

const SpotSanityEventList = ({ data }: Props) => {
  const layout = data?.plugin?.layout
  switch (layout) {
    case 'list-card': {
      const sectionData = toSectionUpcomingEvents(data)
      return <SectionUpcomingEvents {...sectionData} />
    }
    case 'photo-big': {
      const SectionData = toSectionCtaSingle(data)
      return <SectionCtaSingle {...SectionData} />
    }
    case 'photo-big-slide': {
      const sectionData = toSectionSlider(data)
      return <SectionSlider {...sectionData} />
    }
    case 'horizontal-with-images': {
      const sectionData = toSectionFeature(data) as SectionFeatureProps
      return <SectionFeature {...sectionData} variant="event" />
    }
    case 'feature-shop': {
      const sectionData = toSectionFeature(data) as SectionFeatureProps
      return <SectionFeature {...sectionData} variant="shop" />
    }
    case 'cta': {
      const sectionData = toSectionCta(data)
      return <SectionCta {...(sectionData as SectionCtaProps)} />
    }
    case 'detail': {
      return <SpotSanityDetail data={data} variant="event" />
    }
    default: {
      return (
        <Suspense>
          <SpotSanityListEvent data={data} />
        </Suspense>
      )
    }
  }
}

SpotSanityEventList.displayName = 'SpotSanityEventList'

export default memo(SpotSanityEventList)
